import { motion } from "framer-motion";
import { FaHome, FaEnvelope, FaCompass } from "react-icons/fa";

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { duration: 0.55, ease: "easeOut" } },
};

const stagger = {
  hidden: {},
  show: { transition: { staggerChildren: 0.1 } },
};

export default function NotFoundPage() {
  return (
    <div
      style={{
        fontFamily: "'Sora', sans-serif",
        background: "#fafafa",
        color: "#111",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflowX: "hidden",
        padding: "20px",
      }}
    >
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700;800&family=DM+Serif+Display:ital@0;1&display=swap');

        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .container {
          max-width: 1400px;
          width: 100%;
          padding: 24px;
          margin: 0 auto;
        }

        .grid {
          display: grid;
          grid-template-columns: 1.2fr 0.8fr;
          gap: 80px;
          align-items: center;
        }

        /* Tablet */
        @media (max-width: 1024px) {
          .grid {
            grid-template-columns: 1fr 1fr;
            gap: 40px;
          }
        }

        /* Mobile */
        @media (max-width: 768px) {
          .grid {
            grid-template-columns: 1fr;
            gap: 40px;
          }
          
          .left-content {
            order: 1;
            text-align: center;
          }
          
          .right-content {
            order: 0;
            max-width: 400px;
            margin: 0 auto;
          }
          
          .button-group {
            justify-content: center;
          }
          
          .contact-section {
            flex-direction: column !important;
            align-items: center;
            text-align: center;
          }
        }

        /* Small Mobile */
        @media (max-width: 480px) {
          .container {
            padding: 16px;
          }
          
          .left-content {
            padding-right: 0 !important;
          }
          
          .button-group {
            flex-direction: column;
            width: 100%;
          }
          
          .quick-links {
            justify-content: center;
          }
        }

        .tag {
          display: inline-flex; 
          align-items: center; 
          gap: 10px;
          background: #fff; 
          border: 1px solid #e5e5e5;
          border-radius: 100px; 
          padding: 6px 18px;
          font-size: 12px; 
          font-weight: 600; 
          letter-spacing: .08em;
          color: #555; 
          text-transform: uppercase;
        }
        
        .tag-dot { 
          width: 7px; 
          height: 7px; 
          border-radius: 50%; 
          background: #12AF09; 
        }

        .btn-primary {
          display: inline-flex; 
          align-items: center; 
          gap: 10px;
          background: #12AF09; 
          color: #fff;
          padding: 15px 32px; 
          border-radius: 100px;
          font-weight: 700; 
          font-size: 15px;
          text-decoration: none; 
          border: none; 
          cursor: pointer;
          transition: transform .2s, box-shadow .2s;
        }
        
        @media (max-width: 480px) {
          .btn-primary, .btn-outline {
            padding: 12px 24px;
            font-size: 14px;
            width: 100%;
            justify-content: center;
          }
        }
        
        .btn-primary:hover { 
          transform: translateY(-2px); 
          box-shadow: 0 12px 32px rgba(38,189,25,.3); 
        }
        
        .btn-outline {
          display: inline-flex; 
          align-items: center; 
          gap: 10px;
          background: transparent; 
          color: #111;
          padding: 15px 32px; 
          border-radius: 100px;
          font-weight: 600; 
          font-size: 15px;
          border: 2px solid #ddd; 
          cursor: pointer;
          transition: border-color .2s, color .2s;
          text-decoration: none;
        }
        
        .btn-outline:hover { 
          border-color: #12AF09; 
          color: #12AF09; 
        }

        .number-404 {
          font-family: 'DM Serif Display', serif;
          font-size: clamp(100px, 20vw, 280px);
          line-height: 0.8;
          color: #111;
          position: relative;
          display: inline-block;
        }

        @media (max-width: 768px) {
          .number-404 {
            font-size: clamp(80px, 15vw, 120px);
          }
        }

        .number-404 span {
          color: #12AF09;
          font-style: italic;
        }

        .circle-decoration {
          position: absolute;
          border: 2px solid #e5e5e5;
          border-radius: 50%;
          z-index: -1;
        }

        @media (max-width: 768px) {
          .circle-decoration:first-of-type {
            width: 150px !important;
            height: 150px !important;
            right: -20px !important;
          }
          
          .circle-decoration:last-of-type {
            width: 80px !important;
            height: 80px !important;
            left: 60px !important;
          }
        }

        .responsive-image {
          max-width: 100%;
          height: auto;
          border-radius: 20px;
          box-shadow: 0 30px 60px -20px rgba(0,0,0,0.2);
          transition: transform 0.3s ease;
        }

        .responsive-image:hover {
          transform: scale(1.02);
        }

        .quick-links {
          display: flex;
          gap: 20px;
          flex-wrap: wrap;
        }

        @media (max-width: 768px) {
          .quick-links {
            gap: 15px;
            justify-content: center;
          }
        }

        .button-group {
          display: flex;
          gap: clamp(12px, 2vw, 16px);
          flex-wrap: wrap;
        }

        .contact-section {
          display: flex;
          gap: clamp(20px, 4vw, 40px);
          margin-top: 40px;
          padding-top: 40px;
          border-top: 1px solid #e5e5e5;
        }

        .footer-note {
          margin-top: clamp(40px, 6vh, 60px);
          text-align: center;
          font-size: clamp(12px, 2vw, 13px);
          color: #999;
        }
      `}</style>

      <div className="container">
        <motion.div
          variants={stagger}
          initial="hidden"
          animate="show"
          className="grid"
        >
          {/* Left Side - Content */}
          <div className="left-content" style={{ paddingRight: "20px" }}>
            <motion.div variants={fadeUp} style={{ marginBottom: 28 }}>
              <span className="tag">
                <span className="tag-dot" />
                Error 404
              </span>
            </motion.div>

            <motion.div variants={fadeUp} style={{ position: "relative", marginBottom: 24 }}>
              <div className="number-404">
                4<span>0</span>4
              </div>
              
              {/* Decorative circles */}
              <div className="circle-decoration" style={{ 
                width: 'clamp(150px, 20vw, 200px)', 
                height: 'clamp(150px, 20vw, 200px)', 
                top: -40, 
                right: -40 
              }} />
              <div className="circle-decoration" style={{ 
                width: 'clamp(80px, 10vw, 100px)', 
                height: 'clamp(80px, 10vw, 100px)', 
                bottom: 20, 
                left: 120, 
                borderColor: "#12AF09", 
                opacity: 0.3 
              }} />
            </motion.div>

            <motion.h2 
              variants={fadeUp}
              style={{
                fontFamily: "'DM Serif Display', serif",
                fontSize: "clamp(28px, 4vw, 48px)",
                lineHeight: 1.1,
                marginBottom: 16,
                color: "#0d0d0d",
              }}
            >
              Page Not Found
            </motion.h2>

            <motion.p 
              variants={fadeUp}
              style={{
                fontSize: "clamp(15px, 2vw, 17px)",
                lineHeight: 1.7,
                color: "#666",
                maxWidth: 450,
                marginBottom: 40,
              }}
            >
              The page you're looking for doesn't exist or has been moved. 
              Let's get you back on track.
            </motion.p>

            <motion.div 
              variants={fadeUp}
              className="button-group"
            >
              <a href="/" className="btn-primary">
                <FaHome /> Back to Home
              </a>
              <a href="/about" className="btn-outline">
                <FaCompass /> Explore Site
              </a>
            </motion.div>

            <motion.div 
              variants={fadeUp}
              className="contact-section"
            >
              <div>
                <div style={{ fontSize: 13, color: "#999", marginBottom: 4 }}>Need help?</div>
                <a 
                  href="mailto:connect@chainmagicianlab.com" 
                  style={{ 
                    color: "#12AF09", 
                    textDecoration: "none",
                    fontSize: "clamp(13px, 1.5vw, 15px)",
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    wordBreak: "break-all",
                    justifyContent: window.innerWidth <= 768 ? "center" : "flex-start"
                  }}
                >
                  <FaEnvelope /> connect@chainmagicianlab.com
                </a>
              </div>
              <div>
                <div style={{ fontSize: 13, color: "#999", marginBottom: 4 }}>Quick links</div>
                <div className="quick-links">
                  <a href="/services" style={{ color: "#555", textDecoration: "none", fontSize: "clamp(13px, 1.5vw, 14px)" }}>Services</a>
                  <a href="/expertise" style={{ color: "#555", textDecoration: "none", fontSize: "clamp(13px, 1.5vw, 14px)" }}>Expertise</a>
                  <a href="/contact" style={{ color: "#555", textDecoration: "none", fontSize: "clamp(13px, 1.5vw, 14px)" }}>Contact</a>
                </div>
              </div>
            </motion.div>
          </div>

          {/* Right Side - Image */}
          <motion.div 
            variants={fadeUp}
            className="right-content"
            style={{
              position: "relative",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "20px",
            }}
          >
            <div style={{
              position: "relative",
              width: "100%",
              maxWidth: 500,
              margin: "0 auto",
            }}>
              {/* Decorative background elements */}
              <div style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "90%",
                height: "90%",
                background: "radial-gradient(circle, rgba(38,189,25,0.1) 0%, rgba(255,255,255,0) 70%)",
                borderRadius: "50%",
                zIndex: 0,
              }} />
              
              {/* Main image */}
              <img 
                src="./img/404.jpg" 
                alt="Lost in space - 404 illustration"
                className="responsive-image"
                style={{
                  position: "relative",
                  zIndex: 1,
                  width: "100%",
                  height: "auto",
                  borderRadius: "30px",
                  boxShadow: "0 30px 60px -20px rgba(0,0,0,0.3)",
                }}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "https://via.placeholder.com/500x500/12AF09/ffffff?text=404";
                }}
              />
              
              {/* Overlay text */}
              <div style={{
                position: "absolute",
                bottom: "10%",
                right: "5%",
                background: "rgba(255,255,255,0.9)",
                padding: "8px 16px",
                borderRadius: "100px",
                fontSize: "14px",
                color: "#12AF09",
                fontWeight: 600,
                backdropFilter: "blur(5px)",
                zIndex: 2,
              }}>
                🔍 Lost?
              </div>
            </div>
          </motion.div>
        </motion.div>

        {/* Footer note */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8 }}
          className="footer-note"
        >
          © 2024 Chain Magician Lab. All rights reserved.
        </motion.div>
      </div>
    </div>
  );
}